import { Button, Form, Input, Spin } from 'antd'
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from '../../../Services/FetchData';
import { API_ENDPOINTS } from '../../../constants/apiEndPoints';
import bottomArrow from '../../../assets/images/dropdown_icon_red.svg'
import './BillingAddress.scss'
import TextArea from 'antd/es/input/TextArea';
import { businessInfo } from '../../../slices/businessInfo/thunk';
import { api } from '../../../helpers/api_helper';
import { formatInputValue } from '../../../Services/InputFieldService';
import { validationContent } from '../../../constants/Validation';
import { PlaceholderContent } from '../../../constants/Placeholder';
import InputFieldMxLength from '../../../Common/iInputFieldLength/InputFieldLength';


const BillingAddress = ({ uploadStatus, modalData, resetFlag, modalWorking , btnStatus , type }) => {
    let content = validationContent?.BILLING_ADDRESS_POPUP;
    let placeholderContent = PlaceholderContent?.BILLING_ADDRESS;
    const stateParentRef = useRef(null);
    const dispatch = useDispatch();
    let businessInfoDetails = useSelector(state => state.BusinessInfoReducer?.businessInfo);
    const [billingAddress] = Form.useForm();
    const [stateList, setStateList] = useState([]);
    const [activeState, setActiveState] = useState();
    const [isCustomDropdownVisible, setCustomDropdownVisible] = useState(false);
    const [newBillingAddress, setNewBillingAddress] = useState(false);
    const [loading, setLoading] = useState(false);
    const [oldBillingAddressData, setOldBillingAddressData] = useState();
    const [newBillingAddressData, setNewBillingAddressData] = useState();
    const [billingAddressButtonStatus, setBillingAddressButtonStatus] = useState(true);
    const [btnDisable, setBtnDisable] = useState(true)
    const [businessAddressData, setBusinessAddressData] = useState({
        'business_address': '',
        'name': '',
        'phone': '',
        'state': {
            'code': '',
            'label': ''
        },
        'pincode': ''
    })
    const [businessInfoData, setBusinessInfoData] = useState({
        'name': '',
        'phone': '',
        'address': '',
        'pincode': '',
        'state': {
            'code': '',
            'label': ''
        }
    })
    const [billingAddressData, setBillingAddressData] = useState({
        'phone': '',
        'state': {
            'code': '',
            'label': ''
        },
        'pincode': ''
    })
    const [limit, setLimit] = useState({
        'business_name': 150,
        'business_description': 500,
        'business_address': 200,
        'billing_address': 200,
        'pincode': 6,
    })
    const [fieldLengths, setFieldLengths] = useState({});
    useEffect(() => {
        if (businessInfoDetails) {

            
            setOldBillingAddressData(businessInfoDetails?.business_address ? businessInfoDetails?.business_address : businessInfoDetails?.old_business_address);
            setBusinessInfoData({
                name: businessInfoDetails?.business_name ? businessInfoDetails?.business_name : businessInfoDetails?.old_business_name,
                phone: businessInfoDetails?.contact_number,
                address: businessInfoDetails?.business_address ? businessInfoDetails?.business_address : businessInfoDetails?.old_business_address,
                state: {
                    code: businessInfoDetails?.billing_address?.state?.code || 'KL',
                    label: businessInfoDetails?.billing_address?.state?.label || 'Kerala'
                },
                pincode: businessInfoDetails?.pincode,
            })
            setBusinessAddressData((prev) => ({
                ...prev, business_address: businessInfoDetails?.business_address, name: businessInfoDetails?.business_name ? businessInfoDetails?.business_name : businessInfoDetails?.old_business_name,
                phone: businessInfoDetails?.contact_number,
            }))
            setBillingAddressData({
                name: businessInfoDetails?.business_name ? businessInfoDetails?.business_name : businessInfoDetails?.old_business_name,
                phone: businessInfoDetails?.contact_number,
                address: businessInfoDetails?.billing_address?.address,
                state: {
                    code: businessInfoDetails?.billing_address?.state?.code || 'KL',
                    label: businessInfoDetails?.billing_address?.state?.label || 'Kerala'
                },
                pincode: businessInfoDetails?.billing_address?.pincode,
            })

        }
    }, [businessInfoDetails])

    useEffect(() => {
        if (billingAddressData) {
            billingAddress.setFieldsValue({
                business_name: businessInfoData?.name,
                contact_number: '+91 ' + businessInfoData?.phone,
                business_address: businessInfoData?.business_address ? businessInfoData?.business_address : businessInfoDetails?.old_business_address,
                address: billingAddressData?.address,
                old_pincode: businessInfoData?.pincode,
                new_pincode: billingAddressData?.pincode,
                state: billingAddressData?.state?.label,
            })
            setFieldLengths({
                business_name: businessInfoData?.name?.length || 0,
                contact_number: ('+91 ' + businessInfoData?.phone)?.length || 0,
                business_address: businessInfoData?.address?.length || 0,
                address: billingAddressData?.address?.length || 0,
                old_pincode: businessInfoData?.pincode?.length || 0,
                new_pincode: billingAddressData?.pincode?.length || 0,
                state: billingAddressData?.state?.label?.length || 0,
            });
        }
    }, [billingAddressData])


    useEffect(() => {
        const fetchDataAsync = async () => {
            try {
                const endPoint = API_ENDPOINTS.GET_STATE;
                const fetchedData = await fetchData(endPoint);
                if (fetchedData) {
                    setStateList(fetchedData);
                }
            } catch (error) {
                console.error('Error fetching state data:', error);  // More descriptive error message
            }
        };

        fetchDataAsync();
    }, [])

    const handlingRadio = useCallback((value) => {
        setNewBillingAddress(value);
    }, [setNewBillingAddress]);

    const billingAddressModify = (event, field) => {
        let value = event.target.value;
        setBillingAddressData((prev) => ({
            ...prev, [field]: value
        }))
        setFieldLengths((prev) => ({
            ...prev, [field]: value?.length
        }))

    }
    const businessAddressModify = (event, field) => {
        let value = event.target.value;
        if (field === 'pincode') {
            setBusinessInfoData((prev) => ({
                ...prev, [field]: value
            }))
        }
        else {
            setBusinessInfoData((prev) => ({
                ...prev, [field]: value
            }))
        }

        setFieldLengths((prev) => ({
            ...prev, [field]: value?.length
        }))

    }

    const onFinish = () => {
        try {
            setLoading(true);
            if (!newBillingAddress) {
                updateBusinessInfo(businessAddressData, businessAddressData);
            }
            else {
                updateBusinessInfo(businessAddressData, billingAddressData);
            }
        }
        catch (error) {
            setLoading(false);
            console.log('Error fetching form values:', error);
        }
    }
    const updateBusinessInfo = async (b_info, info) => {
        try {
            setLoading(true);

            const billingInfo = info
                ? {
                    ...Object.fromEntries(Object.entries(info).filter(([key]) => key !== "business_address")), // Exclude business_address
                    address: info.business_address || info.address, // Use business_address or fallback to address
                }
                : {};

            const data = await api.create(`${API_ENDPOINTS.BUSINESS_INFO.UPDATE}`, {
                billing_address: billingInfo,
                ...b_info,
            });

            setLoading(false);
            dispatch(businessInfo());
            uploadStatus(true);
        } catch (err) {
            setLoading(false);
            console.log('business info updation error occurred', err);
        }
    };


    const checkErrors = () => {

    }
    const validateMessages = () => {

    }
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    useEffect(() => {
        console.log('uploadStatus', uploadStatus)
        if (modalData) {
            setCustomDropdownVisible(false)
        }
    }, [modalData, uploadStatus]);

    useEffect(() => {
        return () => {
            setCustomDropdownVisible(false)
        };
    }, []);


    useEffect(() => {
        if (activeState) {
            setBillingAddressData((prev) => ({
                ...prev,
                state: {
                    code: activeState?.code,
                    label: activeState?.label
                }
            }));
        }
    }, [activeState]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (stateParentRef.current && !stateParentRef.current.contains(event.target)) {
                setCustomDropdownVisible(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
        console.log('entered')
    }, []);

    // useEffect(() => {
    //     billingAddress.setFieldsValue({ newAddress: '' });
    //     console.log('entered');

    //     return () => {
    //         console.log('Cleanup logic if needed.');
    //     };
    // });


    useEffect(() => {


        if (resetFlag) {
            billingAddress.resetFields();
            if (businessInfoDetails) {
                setOldBillingAddressData(businessInfoDetails?.business_address ? businessInfoDetails?.business_address : businessInfoDetails?.old_business_address);
                setBillingAddressData({
                    name: businessInfoDetails?.business_name ? businessInfoDetails?.business_name : businessInfoDetails?.old_business_name,
                    phone: businessInfoDetails?.contact_number,
                    state: {
                        code: businessInfoDetails?.billing_address?.state?.code || 'KL',
                        label: businessInfoDetails?.billing_address?.state?.label || 'Kerala'
                    },
                    pincode: businessInfoDetails?.billing_address?.pincode,

                })
            }
            modalWorking(false)
        }

    }, [resetFlag])


    useEffect(() => {
        if (businessInfoData) {
            setBusinessAddressData({
                'business_address': businessInfoData.business_address || businessInfoData?.address,
                'pincode': businessInfoData?.pincode,
                'state': businessInfoData?.state
            })
        }
    }, [businessInfoData])

    useEffect(() => {
        console.log('businessInfoDetails', businessInfoDetails)
    }, [businessInfoDetails])

    useEffect(() => {
        if (!newBillingAddress) {
            let business_address = businessInfoDetails?.old_business_address ? businessInfoDetails?.old_business_address : businessInfoDetails?.business_address;
            let business_address_value = businessInfoData?.business_address ? businessInfoData?.business_address : businessInfoDetails?.old_business_address;
            let pin_code = businessInfoDetails?.pincode;
            let pin_code_value = businessInfoData?.pincode;
            if (business_address === business_address_value && pin_code === pin_code_value) {
                setBtnDisable(true)
            }
            else {
                setBtnDisable(false)
            }
        }
        else {
            setBtnDisable(false)
        }
    }, [newBillingAddress, businessInfoData])

    useEffect(()=>{
        console.log('btnStatus' , btnStatus)
    },[btnStatus])

    useEffect(()=>{
        if(!btnStatus ){

        }
    },[])



    return (
        <>
            {
                loading && (
                    <div className="spinner sm center">
                        <Spin />
                    </div>
                )
            }
            <div className="custom_billingAddress">
                <div className="title_wrap " style={{ textAlign: 'center' }}>
                    <h2 className="text_lg text_red">Manage Address</h2>
                    <p className='md'>Provide the address details to be included on the invoices.</p>
                </div>
                <div className="form_wrap">
                    {/* <div className="top">
                        <label className='text_red d-block input_label'>Business Address</label>
                        <div className="address_field">
                            <span className='text_sm business_name_prefilled'>{billingAddressData?.name}</span>
                            <span className='text_sm address_prefilled'>{oldBillingAddressData}</span>
                            <span className='text_sm mob_prefilled'>phone: {'+91 ' + billingAddressData?.phone}</span>
                        </div>
                    </div> */}

                    <Form
                        form={billingAddress}
                        className='form_body'
                        onFinish={onFinish}
                        onFieldsChange={checkErrors}
                        validateMessages={validateMessages}
                        onFinishFailed={onFinishFailed}
                    >
                        <div className="wrap">

                            <div className="wrap">
                                <div className="">
                                    <div className="input_holder">
                                        <label htmlFor="business_name" className="text_red d-block input_label">Business Name</label>
                                        <Form.Item
                                            name="business_name"
                                            onChange={(event) => billingAddressModify(event, 'business_name')}
                                            rules={[{ required: true, message: 'Please enter the business name.' }]}
                                        >
                                            <Input
                                                className="input_field"
                                                placeholder="Enter Business Name"
                                                type="text"
                                                disabled={true}
                                            />
                                        </Form.Item>
                                        <InputFieldMxLength maxValue={limit?.business_name} valueLength={fieldLengths?.business_name} />
                                    </div>
                                    <div className="input_holder">
                                        <label htmlFor="contact_number" className="text_red d-block input_label">Contact Number</label>
                                        <Form.Item
                                            name="contact_number"
                                            // rules={[
                                            //     { required: true, message: 'Enter contact number.' },
                                            //     { pattern: /^\d{10}$/, message: 'Please enter a valid 10-digit mobile number' }
                                            // ]}
                                            onChange={(event) => billingAddressModify(event, 'phone')}
                                        >
                                            <Input
                                                disabled={true}
                                                className="input_field"
                                                placeholder="Enter Contact Number."
                                                type="text"
                                                maxLength={10}
                                                onKeyDown={(e) => {
                                                    if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="input_holder"  >
                                        <label htmlFor="newAddress" className="text_red d-block input_label" >Business Address</label>
                                        <Form.Item
                                            name="business_address"
                                            rules={[{ required: true, message: "Please enter your address." }]}
                                            onChange={(event) => businessAddressModify(event, 'business_address')}
                                        >
                                            <TextArea
                                                style={{ margin: "10px 0", height: 'auto' }}
                                                rows={5}
                                                maxLength={200}
                                                placeholder={placeholderContent?.BusinessAddress}
                                                className="input_field"
                                                disabled={businessInfoDetails?.business_address && false}
                                            />
                                        </Form.Item>
                                        <InputFieldMxLength maxValue={limit?.business_address} valueLength={fieldLengths?.business_address} />
                                    </div>
                                </div>
                                <div className="state_pincode_wrap">
                                    <div className='state_wrap' ref={stateParentRef}>
                                        <div className="state_parent">
                                            <Form.Item
                                                className='custom_error custom_dropdown_parent'
                                                name="state"
                                                rules={[
                                                    { required: true, message: 'Please select the state' },
                                                ]}
                                                label={<span className='input_label text_red d-block text_capitalize'>State</span>}
                                            >
                                                <Input
                                                    className='input_field'
                                                    value={activeState?.label || ''}
                                                    readOnly
                                                    onClick={() => setCustomDropdownVisible(prev => !prev)}
                                                    placeholder={placeholderContent?.State}
                                                    disabled={true}
                                                />
                                            </Form.Item>
                                            {/* <span className='icon custom_bottom_arrow'>
                                            <img src={bottomArrow} alt="" />
                                        </span> */}
                                        </div>
                                        {/* Dropdown */}
                                        {/* <ul className={`${isCustomDropdownVisible ? 'active' : ''} filter_sort_dropdown custom_dropdown`}>
                                        {stateList?.map((el, index) => (
                                            <li key={index} className='md' onClick={() => {
                                                setActiveState(el);
                                                setCustomDropdownVisible(false);
                                            }}>
                                                <span>{el.label}</span>

                                            </li>
                                        ))}
                                    </ul> */}
                                    </div>
                                    <div className="pincode_wrap"><Form.Item
                                        className='custom_error '
                                        name="old_pincode"
                                        label={<span className='input_label text_red d-block text_capitalize'>Pin Code</span>}
                                        rules={[
                                            { required: true, message: content?.EnterPinCode },
                                            { pattern: /^[0-9]{6}$/, message: 'Pin code must be exactly 6 digits' }
                                        ]}
                                        onChange={(event) => businessAddressModify(event, 'pincode')}
                                    >
                                        <Input
                                            maxLength={6}
                                            className='input_field text_transform_normal'
                                            placeholder={placeholderContent?.PinCode}
                                            onKeyPress={(e) => {
                                                if (!/^\d$/.test(e.key)) {
                                                    e.preventDefault();  // Prevent typing non-digit characters
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                        <InputFieldMxLength maxValue={limit?.pincode} valueLength={fieldLengths?.old_pincode} />
                                    </div>
                                </div>
                            </div>
                            <ul className={`custom_radio_group ${newBillingAddress ? 'radio_group_active' : ''}`}>
                                <li className='md' onClick={() => setNewBillingAddress(false)}>
                                    <span></span>Select this business address as the billing address.
                                </li>
                                <li className="md" onClick={() => setNewBillingAddress(true)}>
                                    <span></span>Add a new billing address.
                                </li>
                            </ul>
                            {newBillingAddress && (
                                <div className="new_billingAddress">
                                    <div className="input_holder" >
                                        <label htmlFor="newAddress" className="text_red d-block input_label">Billing Address</label>
                                        <Form.Item
                                            name="address"
                                            rules={[{ required: true, message: "Please enter your address." }]}
                                            onChange={(event) => billingAddressModify(event, 'address')}
                                        >
                                            <TextArea
                                                style={{ margin: "10px 0" }}
                                                rows={5}
                                                maxLength={200}
                                                placeholder={placeholderContent?.BillingAddress}
                                                className="input_field"
                                                style={{ height: 'auto' }}
                                            />
                                        </Form.Item>
                                        <InputFieldMxLength maxValue={limit?.business_address} valueLength={fieldLengths?.address} />
                                    </div>
                                    <div className="state_pincode_wrap">
                                        <div className='state_wrap' ref={stateParentRef}>
                                            <div className="state_parent">
                                                <Form.Item
                                                    className='custom_error custom_dropdown_parent'
                                                    name="state"
                                                    rules={[
                                                        { required: true, message: 'Please select the pin code' },
                                                    ]}
                                                    label={<span className='input_label text_red d-block text_capitalize'>State</span>}
                                                >
                                                    <Input
                                                        className='input_field'
                                                        value={activeState?.label || ''}
                                                        readOnly
                                                        onClick={() => setCustomDropdownVisible(prev => !prev)}
                                                        placeholder={placeholderContent?.State}
                                                        disabled={true}
                                                    />
                                                </Form.Item>
                                                {/* <span className='icon custom_bottom_arrow'>
                                            <img src={bottomArrow} alt="" />
                                        </span> */}
                                            </div>
                                            {/* Dropdown */}
                                            {/* <ul className={`${isCustomDropdownVisible ? 'active' : ''} filter_sort_dropdown custom_dropdown`}>
                                        {stateList?.map((el, index) => (
                                            <li key={index} className='md' onClick={() => {
                                                setActiveState(el);
                                                setCustomDropdownVisible(false);
                                            }}>
                                                <span>{el.label}</span>

                                            </li>
                                        ))}
                                    </ul> */}
                                        </div>
                                        <div className="pincode_wrap"><Form.Item
                                            className='custom_error '
                                            name="new_pincode"
                                            label={<span className='input_label text_red d-block text_capitalize'>Pin Code</span>}
                                            rules={[
                                                { required: true, message: content?.EnterPinCode },
                                                { pattern: /^[0-9]{6}$/, message: 'Pin code must be exactly 6 digits' }
                                            ]}
                                            onChange={(event) => billingAddressModify(event, 'pincode')}
                                        >
                                            <Input
                                                maxLength={6}
                                                className='input_field text_transform_normal'
                                                placeholder={placeholderContent?.PinCode}
                                                onKeyPress={(e) => {
                                                    if (!/^\d$/.test(e.key)) {
                                                        e.preventDefault();  // Prevent typing non-digit characters
                                                    }
                                                }}
                                            />
                                        </Form.Item>
                                            <InputFieldMxLength maxValue={limit?.pincode} valueLength={fieldLengths?.new_pincode} />

                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                        <div className=" button_wrap" style={{ textAlign: 'center' }}>
                            <Button
                                className='wide'
                                type="primary"
                                htmlType="submit"
                                // disabled={!btnStatus ? false : btnDisable}
                            >
                                Submit
                            </Button>
                        </div>
                    </Form>
                </div >
            </div >
        </>
    )
}

export default BillingAddress